export default {
    postRead: 'message-notifications/read',
    postSearch: 'message-notifications/search',
    postMakeAsRead: 'message-notifications/:id/makeAsRead',
    postSendMail: 'message-notifications/sendMail',
    getDetail: 'message-notifications/:id/detail',
    getMessageToSendMail: 'message-notifications/:id/getMessageToSendMail'
}